class ShopifyCustomizer extends HTMLElement {
    
  // 👇 新增：声明要观察的属性
  static get observedAttributes() {
    return ['data-bg'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = `
      <style>
        .form-group {
          margin-bottom: 10px;
        }
        .form-group label {
          display: block;
          text-transform: uppercase;
          font-size: 14px;
          margin-bottom: 5px;
        }
        .form-group input {
          text-align: left;
          font-size: 14px;
          appearance: none;
          width: 100%;
          box-sizing: border-box;
          position: relative;
          padding: 10px;
        }
        .canvas-container, .canvas {
          display: none;
        }
        .color-palette {
          display: flex;
          flex-wrap: wrap;
          gap: 5px;
        }
        .color-palette .color-box {
          width: 30px;
          height: 30px;
          border: 2px solid #eee;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          border-radius: 50%;
        }
        .color-palette .color-box.color-selected {
          border-color: #000;
        }

      </style>
      <canvas id="canvas" width="600" height="800"></canvas>

      <div class="form-pod">
        <div class="form-group">
          <label for="textInput">${this.dataset.labelText}</label>
          <input type="text" id="textInput" maxlength="5" />
        </div>
        <div class="form-group">
          <label>${this.dataset.labelColor}</label>
          <div id="colorPalette" class="color-palette"></div>
        </div>
      </div>
    `;

    this.configJson = JSON.parse(this.querySelector('script[type="application/json"]').innerHTML);
    this.loadFont().then(() => {
      this.init();
      this.observeEvent();
      this.galleryBaseSrc = '';
    })
  }

  async loadFont() {
    const font = new FontFace('Montserrat', `url(${this.dataset.font})`, {
      style: 'normal',
      weight: 'normal'
    });

    await font.load();
    document.fonts.add(font);

    await document.fonts.ready;
  }

  observeEvent() {
    document.addEventListener('color-changed', () => {
      setTimeout(() => {
        this.initBackGround()
      }, 500)
    });


    var that = this;
    (() => {
      // 获取目标元素
      const target = that.closest('.collapsibles-wrapper').querySelector('.collapsible-pod-btn');
      // 创建一个 MutationObserver 实例
      const observer = new MutationObserver((mutationsList) => {

        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
            const newValue = target.getAttribute('aria-expanded');
            if (newValue != 'true') {
              that.inputText = ''
            }
          }
        }
      });

      // 配置 observer，观察属性变化
      observer.observe(target, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    })()
  }

  initBackGround() {
    const slide0Img = document.querySelector('#pwzrswiper-img-0')
    if (slide0Img && slide0Img.src.indexOf('https') > -1 && this.galleryBaseSrc !== slide0Img.src) {
      this.galleryBaseSrc = slide0Img.src;
      this.setBackground(this.galleryBaseSrc)
    }
    console.log('now:' + this.galleryBaseSrc)
  }

  coverGallery() {
    // 需要先看下背景颜色图片是否发生变化
    const slide0Img = document.querySelector('#pwzrswiper-img-0')
    if (!slide0Img) return
    const canvasBase64 = this.canvas.toDataURL({ format: 'png', quality: 1 })
    slide0Img.src = canvasBase64
    slide0Img.setAttribute('data-zoom', canvasBase64)
  }

  set inputText(val) {
    const inputEle = this.querySelector('#podText')
    inputEle.value = val;
    var paymentButton = document.querySelector('.shopify-payment-button')
    if (!val) {
      Array.from(this.querySelectorAll('input')).forEach(f => {
        f.removeAttribute('form');
      })
      this.shadowRoot.getElementById('textInput').value = ''
      if (this.configJson.addFeeId && paymentButton) {
        paymentButton.style.display = 'block'
      }
    } else {
      Array.from(this.querySelectorAll('input')).forEach(f => {
        f.setAttribute('form', inputEle.dataset.form);
      })
      if (this.configJson.addFeeId && paymentButton) {
        paymentButton.style.display = 'none'
      }
    }
    this.text.text = val;
    this.renderCanvas()
  }

  set inputColor(val) {
    const inputEle = this.querySelector('#podColor')
    inputEle.value = val;
  }

  generateUUID() {
    const timestamp = Date.now().toString(36); // 时间戳转为36进制
    const randomStr = Math.random().toString(36).substring(2, 10); // 随机串
    return `${timestamp}-${randomStr}`;
  }

  async init() {

    this.querySelector('#podMainId').value = this.generateUUID();

    const canvas = new fabric.Canvas(this.shadowRoot.getElementById('canvas'), {
      backgroundColor: '#fff'
    });
    this.canvas = canvas;

    const text = new fabric.Textbox('', {
      left: canvas.width / 2,
      top: 700,
      width: 500,
      fontSize: 36,
      fontFamily: 'Montserrat',
      textAlign: 'center',
      originX: 'center',
      originY: 'center',
      shadow: 'rgba(0,0,0,0.3) 2px 2px 5px',
      angle: this.configJson.rotate || 0,
      editable: false,
      selectable: false
    });
    canvas.add(text);
    this.text = text;

    this.loadConfig();

    const regexPattern = (this.configJson.charTypes || ['upletter']).map(i => {
      return { upletter: 'A-Z', downletter: 'a-z', number: '0-9' }[i]
    }).join('')

    // 输入限制与更新
    this.shadowRoot.getElementById('textInput').addEventListener('input', e => {
      const regex = new RegExp(`[^${regexPattern}]+`, 'g');
      const clean = e.target.value.replace(regex, '').slice(0, 5);
      e.target.value = clean;
      this.inputText = clean;
    });

    // 动态颜色更新
    if (this.shadowRoot.getElementById('colorPicker')) {
      this.shadowRoot.getElementById('colorPicker').addEventListener('input', () => {
        this.updateDynamicColor(text, canvas);
      });
    }
  }

  loadConfig() {
    if (this.configJson) {
      try {
        const { colors, fontSize, textPosition } = this.configJson;

        // 清空现有颜色列表
        const colorPalette = this.shadowRoot.getElementById('colorPalette');
        colorPalette.innerHTML = '';

        // 初始化颜色列表
        colors.forEach((color, index) => {
          const colorBox = document.createElement('div');
          colorBox.className = 'color-box ' + (index == 0 ? 'color-selected' : '');
          colorBox.style.backgroundColor = color;
          colorBox.dataset.color = color;
          colorBox.addEventListener('click', () => {
            this.text.set('fill', color);
            this.renderCanvas()
            colorPalette.querySelectorAll('.color-box').forEach(box => {
              box.classList.remove('color-selected');
            });
            colorBox.classList.add('color-selected');
            this.inputColor = color;
          });
          colorPalette.appendChild(colorBox);
        });

        // 初始化字体大小
        this.text.set('fontSize', fontSize);
        this.text.set('top', textPosition);
        this.text.set('fill', colors[0]);
        this.inputColor = colors[0];
        this.renderCanvas()
      } catch (err) {
        console.log('配置加载失败:', err);
      }
    }
  }

  updateDynamicColor(text, canvas) {
    const colorPicker = this.shadowRoot.getElementById('colorPicker').value;
    text.set('fill', colorPicker);
    this.renderCanvas()
  }

  // 👇 新增方法：统一设置背景图
  setBackground(url) {
    const canvas = this.canvas;

    const existingBgImage = canvas.getObjects().find(obj => obj.type === 'image');
    if (existingBgImage) {
      canvas.remove(existingBgImage);
    }

    fabric.Image.fromURL(url, img => {
      canvas.setBackgroundColor('#fff', canvas.renderAll.bind(canvas));
      const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
      img.scale(scale);
      img.set({ left: (canvas.width - img.width * scale) / 2, top: 0, selectable: false });
      canvas.add(img);

      // 确保背景图片始终在最底层
      canvas.sendToBack(img);
      this.coverGallery();
    }, { crossOrigin: 'anonymous', type: 'image' });
  }

  renderCanvas() {
    if (!this.galleryBaseSrc) {
      this.initBackGround();
    }
    this.canvas.renderAll();
    this.coverGallery();
  }
}

customElements.define('shopify-customizer', ShopifyCustomizer);